<template>
  <div class="loginAll">
    <div class="login">
      <div class="login_top ovh">
        <div class="f_l login_top_img">
          <img src="../../static/loginTop.png" />
        </div>
        <div class="f_r close" @click="close()">
          <img src="../../static/close.png" />
        </div>
      </div>
      <!-- 框 -->
      <div class="frame">
        <div class="codeImg ovh">
          <div class="img">
            <img src="../../static/app.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // 引入共用的css
	import "../components/css/component.css";
  import "../components/css/input.css";

  export default {
    name: 'payOrder',
    data () {
      return {
        
      }
    },

    mounted() {
      
    },

    computed:{
      
    },

    show() {

    },

    methods:{
      // 进入页面执行的操作
      init() {
        
      },

      // 关闭弹框
      close() {
        // 执行父组件的方法
        this.$emit('payReturn')
      }
    }
  }
</script>

<!-- 样式 -->
<style scoped lang="scss">
  .loginAll {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0,0,0,.5);
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    // 框
    .login {
      width: 644px;
      height: 456px;
      background-color: #FFFFFF;
      border-radius: 8px;
      &> .login_top {
        height: 70px;
        lin-height: 70px;
        background-color: #FF7702;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        padding: 0 16px;
        &> .login_top_img {
          width: 565px;
          height: 24px;
          margin: 23px 0 0 10px;
        }
        &> .close {
          width: 24px;
          height: 24px;
          font-size: 25px;
          line-height: 70px;
          margin-top: 3px;
          cursor: pointer;
        }
      }
      // 框
      &> .frame {
        width: 100%;
        height: 386px;
        display: flex;
        align-items: center;
        justify-content: center;
        &> .codeImg {
          box-shadow: 0px 2px 12px 0px rgba(148, 148, 149, 0.5);
          border-radio: 4px;
          & .img {
            margin: 2px;
            width: 174px;
            height: 174px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/payOrder.vue